import React from 'react';

import { FAMILY_STANDARD } from 'depop/styles/typography';

import { css } from 'glamor';

function FooterMenuItem({ children }: { children: React.Element }) {
  return React.cloneElement(
    children,
    css({
      display: 'block',
      fontSize: 16,
      lineHeight: '20px',
      color: 'inherit',
      textDecoration: 'none',
      fontFamily: FAMILY_STANDARD,
      cursor: 'pointer',
      ':hover': {
        textDecoration: 'underline',
      },
    }),
  );
}

export default FooterMenuItem;



// WEBPACK FOOTER //
// ../src/client/components/layout/navigation/FooterMenuItem.js